export function parseOnboardingInfo(
  onboardingInfo?: string | null,
): Record<string, unknown> {
  if (!onboardingInfo) return {}
  try {
    return JSON.parse(onboardingInfo) as Record<string, unknown>
  } catch {
    return {}
  }
}

// `showGetStarted` is set on the signup paths and removed when the merchant
// dismisses the get-started page (post-approval, post-bank-link). Its
// presence is the source of truth for "merchant is mid-onboarding" gates.
export function isInNewOnboarding(
  onboardingInfo: Record<string, unknown>,
): boolean {
  return !!onboardingInfo.showGetStarted
}

// Merchants who submitted before the applicationSubmittedAt rename only have
// the legacy applicationSubmitted boolean; honor both markers.
export function hasSubmittedApplication(
  onboardingInfo: Record<string, unknown>,
): boolean {
  return !!(
    onboardingInfo.applicationSubmittedAt || onboardingInfo.applicationSubmitted
  )
}

// Orgs migrated onto the new flow by the 06_09_2026 `showGetStarted` backfill
// entered their details in the legacy onboarding/manual-bank flow, which stored
// them under these keys but never wrote `lastCompletedStep` (a new-flow-only
// marker). Detect that data so the new application hydrates the form instead of
// opening blank. Every one of these keys is mapped by the onboarding store's
// `loadSavedProgress`.
const LEGACY_ONBOARDING_DATA_KEYS = [
  'legalName',
  'taxId',
  'stateIncorporated',
  'ownerFirstName',
  'ownerLastName',
  'ownerSSN',
  'dateOfBirth',
  'accountNumber',
  'accountName',
  'accountHolder',
  'routingNumber',
  'manualBankReviewRequested',
] as const

export function hasLegacyOnboardingData(
  onboardingInfo: Record<string, unknown>,
): boolean {
  return LEGACY_ONBOARDING_DATA_KEYS.some((key) => {
    const value = onboardingInfo[key]
    return typeof value === 'string' ? value.trim() !== '' : Boolean(value)
  })
}
